import { galleryLeftButton, galleryRightButton } from '@project/theme-buttons'


export const gallery4Theme = {
  rightButton: galleryRightButton,
  leftButton: galleryLeftButton,
  outerContainerStyle: "height:80vh",
  coverLayerStyle: "background-color:rgba(0,0,0,0)",
  tabGroup: {
    outerContainerStyle: "left:50%; top:auto; bottom:5px; transform:translateX(-50%);",
    outerContainerClasses: { override:"sb-abox fbicc-header-gallery-tablist" }
  }
}

export const homePageHeaderGallery4 = {
  rightButton: galleryRightButton,
  leftButton: galleryLeftButton,
  outerContainerStyle: "height:calc(100vh - 150px)",
  coverLayerStyle: "background-color:rgba(0,0,0,0.3)",
  tabGroup: {
    outerContainerStyle: "left:50%; top:auto; bottom:5px; transform:translateX(-50%);",
    outerContainerClasses: { override:"sb-abox fbicc-header-gallery-tablist" }
  }
}